'use client';

import ProxyImage from '@shared/ProxyImage/ProxyImage';
import Link from 'next/link';

import {ArticleType} from '@strapi/types';

import styles from './ArticleView.module.scss';

type Props = {
  article: ArticleType;
  onSimilarArticleClick?: (article: ArticleType) => void;
  articleUrl: string;
};

export default function ArticleView({
  article,
  onSimilarArticleClick,
  articleUrl,
}: Props) {
  return (
    <Link
      className={styles.root}
      href={`/${articleUrl}/${article.href}`}
      onClick={() => onSimilarArticleClick?.(article)}
    >
      <div className={styles.imageContainer}>
        {article.cardBackgroundImage && (
          <ProxyImage
            imageData={article.cardBackgroundImage}
            className={styles.image}
          />
        )}
      </div>
      <div className={styles.title}>{article.cardTitle}</div>
    </Link>
  );
}
